import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';
import { SearchIcon } from '../common/mdPageIcons';

function getEstadoActaLabel(rawEstado) {
  const estado = (rawEstado || '').trim();
  if (estado === 'Pendiente') return 'Pendiente';
  if (estado === 'ISN') return 'Impresa';
  if (estado === 'Cargada') return 'Cargada';
  if (estado === 'Cerrada') return 'Cerrada';
  return estado || '—';
}

function getEstadoActaBadgeClass(rawEstado) {
  const estado = (rawEstado || '').trim();
  if (estado === 'Pendiente') return 'md-page__badge md-page__badge--warning';
  if (estado === 'ISN') return 'md-page__badge md-page__badge--info';
  if (estado === 'Cargada') return 'md-page__badge md-page__badge--success';
  if (estado === 'Cerrada') return 'md-page__badge md-page__badge--danger';
  return 'md-page__badge';
}

function getTipoActaLabel(tipo) {
  if (tipo === 'R') return 'Regular';
  if (tipo === 'L') return 'Libre';
  if (tipo === 'E') return 'Equivalencia';
  return '';
}

function getTipoActaBadgeClass(tipo) {
  if (tipo === 'R') return 'md-page__badge md-page__badge--success';
  if (tipo === 'L') return 'md-page__badge md-page__badge--warning';
  if (tipo === 'E') return 'md-page__badge md-page__badge--info';
  return 'md-page__badge';
}

export class MDActaExamen extends Component {
  static displayName = MDActaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: MD_PAGE_SIZE,
      paginationData: [],
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      closingId: null,
      printingId: null,
      pendingClose: null,
    };
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    if (constantClass.canAccess('WWActasExamen')) {
      this.populateData();
    }
  }

  handleCloseRequest = (acta) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingClose: {
        id: acta.actaExamenNacta,
        nombre: acta.materiaCarreraNombre,
      },
    });
  };

  handleCancelClose = () => {
    if (this.state.closingId) return;
    this.setState({ pendingClose: null });
  };

  handleConfirmClose = () => {
    const { pendingClose } = this.state;
    if (!pendingClose || isMdMutationLocked(this)) return;
    this.closeItem(pendingClose.id);
  };

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  clearFeedback = () => {
    this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  buildRowActions(acta) {
    const id = acta.actaExamenNacta;
    const estado = acta.actaExamenEstado.trim();
    const actions = [];

    if (estado === 'ISN') {
      actions.push({
        key: 'load',
        label: 'Cargar Resultados',
        variant: 'primary',
        icon: 'pencil',
        to: '/aex/load/' + id,
      });
    }

    if (estado === 'Cargada') {
      actions.push({
        key: 'close',
        label: this.state.closingId === id ? 'Cerrando...' : 'Cerrar',
        variant: 'primary',
        icon: 'lock',
        onClick: () => this.handleCloseRequest(acta),
        disabled: this.state.loading || this.state.closingId === id,
      });
    }

    actions.push({
      key: 'watch',
      label: 'Ver Acta',
      variant: 'outline',
      icon: 'info',
      to: '/aex/watch/' + id,
    });

    if (estado === 'Pendiente') {
      actions.push({
        key: 'print',
        label: this.state.printingId === id ? 'Imprimiendo...' : 'Imprimir Acta',
        variant: 'primary',
        icon: 'printer',
        onClick: () => this.imprimirActa(id),
        disabled: this.state.loading || this.state.printingId === id,
      });
    }

    actions.push({
      key: 'header',
      label: 'Modificar Encabezado',
      variant: 'outline',
      icon: 'pencil',
      to: '/update-eae/' + id,
    });

    return actions;
  }

  renderTable(actas) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed md-acta-examen__table" aria-labelledby="md-acta-examen-title">
          <colgroup>
            <col className="md-acta-examen__col-materia" />
            <col className="md-acta-examen__col-carrera" />
            <col className="md-acta-examen__col-mesa" />
            <col className="md-acta-examen__col-fecha-examen" />
            <col className="md-acta-examen__col-estado" />
            <col className="md-acta-examen__col-tipo" />
            <col className="md-acta-examen__col-libro" />
            <col className="md-acta-examen__col-folio" />
            <col className="md-acta-examen__col-actions" />
          </colgroup>
          <thead>
            <tr>
              <MdTableHeaderCell cellType="text">Materia</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Carrera</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Mesa de Examen</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date">Fecha de Examen</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-acta-examen__cell md-acta-examen__cell--estado md-page__table__badge-cell">Estado</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-acta-examen__cell md-acta-examen__cell--tipo md-page__table__badge-cell">Tipo</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-acta-examen__cell md-acta-examen__cell--libro">Libro</MdTableHeaderCell>
              <MdTableHeaderCell cellType="number" className="md-acta-examen__cell md-acta-examen__cell--folio">Folio</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {actas.map((acta) => (
              <tr key={acta.actaExamenNacta}>
                <MdTableCell cellType="text">{acta.materiaCarreraNombre}</MdTableCell>
                <MdTableCell cellType="text">{acta.carreraNombre}</MdTableCell>
                <MdTableCell cellType="text">
                  {acta.periodoExamenDescripcion.trim() + ' - ' + acta.periodoExamenLlamado.trim() + ' - ' + acta.anioAcademicoDescripcion.trim()}
                </MdTableCell>
                <MdTableCell cellType="date">{constantClass.formatDisplayDate(acta.mesaExamenFechaExamen)}</MdTableCell>
                <MdTableCell cellType="text" className="md-acta-examen__cell md-acta-examen__cell--estado md-page__table__badge-cell">
                  <span className={getEstadoActaBadgeClass(acta.actaExamenEstado)}>
                    {getEstadoActaLabel(acta.actaExamenEstado)}
                  </span>
                </MdTableCell>
                <MdTableCell cellType="text" className="md-acta-examen__cell md-acta-examen__cell--tipo md-page__table__badge-cell">
                  <span className={getTipoActaBadgeClass(acta.actaExamenTipo)}>
                    {getTipoActaLabel(acta.actaExamenTipo)}
                  </span>
                </MdTableCell>
                <MdTableCell cellType="text" className="md-acta-examen__cell md-acta-examen__cell--libro">{acta.actaExamenLibro}</MdTableCell>
                <MdTableCell cellType="number" className="md-acta-examen__cell md-acta-examen__cell--folio">{acta.actaExamenFolio}</MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions items={this.buildRowActions(acta)} />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching;
    const listLoading = this.state.loading && !this.state.closingId && !this.state.printingId;
    const { pendingClose } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-acta-examen">
        <h1 id="md-acta-examen-title" className="md-page__title">Manejar Datos de Actas de Examen</h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
          <div className="md-page__search-wrap">
            <span className="md-page__search-icon">
              <SearchIcon />
            </span>
            <input
              ref={this.searchInputRef}
              className="md-page__search-input"
              type="text"
              name="search"
              autoComplete="off"
              disabled={isBusy}
              placeholder="Ingrese el nombre de la materia"
              value={this.state.searchInput}
              onChange={this.handleSearchInputChange}
            />
          </div>
          <button type="submit" className="md-page__search-btn" disabled={isBusy}>
            Buscar
          </button>
        </form>

        {contents}

        {!listLoading && this.state.pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={Math.floor(this.state.offset / this.state.perPage)}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingClose)}
          title="Cerrar acta de examen"
          message="¿Está seguro de que desea cerrar el acta? Esta acción no se puede deshacer."
          detail={pendingClose ? pendingClose.nombre : ''}
          confirmLabel="Cerrar acta"
          cancelLabel="Cancelar"
          variant="primary"
          confirmIcon="lock"
          loading={Boolean(this.state.closingId)}
          onConfirm={this.handleConfirmClose}
          onCancel={this.handleCancelClose}
        />
      </div>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/aex/Index',
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }

  imprimirActa = (id) => {
    this.ImprimirActa(id);
  };

  async ImprimirActa(id) {
    this.clearFeedback();
    this.setState({ printingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/aex/print/' + id, {
        method: 'GET',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data)) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo imprimir el acta. Intente nuevamente.'
          ),
        });
        return;
      }
      const byteCharacters = atob(data.returnModel);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'actaExamen.pdf';
      link.click();
      this.setState({ successMessage: 'El acta se descargó correctamente.' });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ printingId: null });
  }

  async closeItem(id) {
    this.clearFeedback();
    this.setState({ closingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/aex/cerrar/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data)) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo cerrar el acta. Intente nuevamente.'
          ),
          pendingClose: null,
        });
        return;
      }
      this.setState({
        successMessage: 'El acta se cerró correctamente.',
        pendingClose: null,
        searchInput: '',
      });
      await this.populateData(0, '', { background: false });
    });
    this.setState({ closingId: null });
  }
}
